<template>
  <div class="body-div">
    <div class="top-div">
      <div class="table">
        <table>
          <thead>
            <tr class="text-center">
              <th>SCHEDULED CALLS</th>
              <th class="td-count">TODAY</th>
              <th class="td-count">LAST 30 DAYS</th>
              <!--              <th class="td-count">LAST MONTH</th>-->
              <!--              <th class="td-count">TOTAL</th>-->
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="regular in paginate(reports['ca'], pageNum, 26)"
              :key="regular.id"
            >
              <td>{{ regular.user.full_name }}</td>
              <td class="td-count">{{ regular.count_today }}</td>
              <td class="td-count">{{ regular.count_month }}</td>
              <!--              <td class="td-count">{{ regular.count_last_month }}</td>-->
              <!--              <td class="td-count">-->
              <!--                {{ regular.count_month + regular.count_last_month }}-->
              <!--              </td>-->
              <td v-for="cond in regular.campaign_aaid" :key="cond.id">
                <span>{{ cond.id }} | {{ cond.amount }}</span>
              </td>
              <td v-for="cond in regular.country_id" :key="cond.id">
                <span
                  >{{
                    dictionaries.general.countries.find(
                      country => country.id === cond.id
                    ).name
                  }}
                  | {{ cond.amount }}</span
                >
              </td>
              <td v-for="cond in regular.keyword" :key="cond.id">
                <span>{{ cond.id }} | {{ cond.amount }}</span>
              </td>
            </tr>
          </tbody>
        </table>

        <table>
          <thead>
            <tr class="text-center">
              <th>AUTO SCHEDULED CALLS</th>
              <th class="td-count">TODAY</th>
              <th class="td-count">LAST 30 DAYS</th>
              <!--              <th class="td-count">LAST MONTH</th>-->
              <!--              <th class="td-count">TOTAL</th>-->
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="auto in paginate(reports['auto_ca'], pageNum, 26)"
              :key="auto.id"
            >
              <td>{{ auto.user.full_name }}</td>
              <td class="td-count">{{ auto.count_today }}</td>
              <td class="td-count">{{ auto.count_month }}</td>
              <!--              <td class="td-count">{{ auto.count_last_month }}</td>-->
              <!--              <td class="td-count">-->
              <!--                {{ auto.count_month + auto.count_last_month }}-->
              <!--              </td>-->
              <td v-for="cond in auto.campaign_aaid" :key="cond.id">
                <span>{{ cond.id }} | {{ cond.amount }}</span>
              </td>
              <td v-for="cond in auto.country_id" :key="cond.id">
                <span
                  >{{
                    dictionaries.general.countries.find(
                      country => country.id === cond.id
                    ).name
                  }}
                  | {{ cond.amount }}</span
                >
              </td>
              <td v-for="cond in auto.keyword" :key="cond.id">
                <span>{{ cond.id }} | {{ cond.amount }}</span>
              </td>
            </tr>
          </tbody>
        </table>

        <table>
          <thead>
            <tr class="text-center">
              <th>STATUSES</th>
              <th class="td-count">TODAY</th>
              <th class="td-count">LAST 30 DAYS</th>
              <!--              <th class="td-count">LAST MONTH</th>-->
              <!--              <th class="td-count">TOTAL</th>-->
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="regular in paginate(reports['status'], pageNum, 26)"
              :key="regular.id"
            >
              <td>{{ regular.status.type | truncate(25) }}</td>
              <td class="td-count">{{ regular.count_today }}</td>
              <td class="td-count">{{ regular.count_month }}</td>
              <!--              <td class="td-count">{{ regular.count_last_month }}</td>-->
              <!--              <td class="td-count">-->
              <!--                {{ regular.count_month + regular.count_last_month }}-->
              <!--              </td>-->

              <td v-for="cond in regular.campaign_aaid" :key="cond.id">
                <span>{{ cond.id }} | {{ cond.amount }}</span>
              </td>
              <td v-for="cond in regular.country_id" :key="cond.id">
                <span
                  >{{
                    dictionaries.general.countries.find(
                      country => country.id === cond.id
                    ).name
                  }}
                  | {{ cond.amount }}</span
                >
              </td>
              <td v-for="cond in regular.keyword" :key="cond.id">
                <span>{{ cond.id }} | {{ cond.amount }}</span>
              </td>
              <td v-for="cond in regular.users" :key="cond.id">
                {{
                  salesPersonList.find(item => item.id === cond.id).full_name
                }}
                | {{ cond.amount }}
              </td>
            </tr>
          </tbody>
        </table>

        <table>
          <thead>
            <tr class="text-center">
              <th>AUTO STATUSES</th>
              <th class="td-count">TODAY</th>
              <th class="td-count">LAST 30 DAYS</th>
              <!--              <th class="td-count">LAST MONTH</th>-->
              <!--              <th class="td-count">TOTAL</th>-->
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="auto in paginate(reports['auto_status'], pageNum, 26)"
              :key="auto.id"
            >
              <td>{{ auto.status.type | truncate(16) }}</td>
              <td class="td-count">{{ auto.count_today }}</td>
              <td class="td-count">{{ auto.count_month }}</td>
              <!--              <td class="td-count">{{ auto.count_last_month }}</td>-->
              <!--              <td class="td-count">-->
              <!--                {{ auto.count_month + auto.count_last_month }}-->
              <!--              </td>-->

              <td v-for="cond in auto.campaign_aaid" :key="cond.id">
                <span>{{ cond.id }} | {{ cond.amount }}</span>
              </td>
              <td v-for="cond in auto.country_id" :key="cond.id">
                <span
                  >{{
                    dictionaries.general.countries.find(
                      country => country.id === cond.id
                    ).name
                  }}
                  | {{ cond.amount }}</span
                >
              </td>
              <td v-for="cond in auto.keyword" :key="cond.id">
                <span>{{ cond.id }} | {{ cond.amount }}</span>
              </td>
              <td v-for="cond in auto.users" :key="cond.id">
                {{
                  salesPersonList.find(item => item.id === cond.id).full_name
                }}
                | {{ cond.amount }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="flat-bottom-div">
        <div class="paginationContainer text-center">
          <div class="btn-group ">
            <button
              v-if="pageNum !== 1"
              @click="backPage"
              class="btn btn-sm s-btn-sm page-btn"
              :disabled="pageNum === 1"
            >
              <i class="fa fa-chevron-left"></i>
            </button>
            <span class="btn btn-sm s-btn-sm page-num ">
              {{ pageNum }}
            </span>
            <button
              v-if="paginate(reports['ca'], pageNum + 1, 26).length !== 0"
              @click="nextPage"
              class="btn btn-sm s-btn-sm page-btn"
              :disabled="paginate(reports['ca'], pageNum + 1, 26).length === 0"
            >
              <i class="fa fa-chevron-right"></i>
            </button>
          </div>
        </div>
        <div class="fab"><span class="fas fa-file-csv"></span></div>
      </div>

      <loader
        class="loader"
        :size="'8px'"
        v-if="
          reqReportsBusy['ca'] ||
            reqReportsBusy['auto_ca'] ||
            reqReportsBusy['status'] ||
            reqReportsBusy['auto_status']
        "
      ></loader>
    </div>
    <div class="bottom-div" v-if="false">
      <span v-if="false"
        >Forbidden, You are not authorized to see this data</span
      >

      <loader :size="'11px'" v-if="reqReportsBusy"></loader>

      <div class="fab"><span class="fas fa-file-csv"></span></div>
    </div>
  </div>
</template>

<script>
import Loader from "../../../../../main/misc.main/loader/Loader";
import {mapGetters, mapState} from "vuex";
import apiClientCreator from "../../../../../helpers/api/request";
export default {
  name: "Assignments.container",
  components: { Loader },
  data() {
    return {
      reqReportsBusy: {
        ca: false,
        auto_ca: false,
        status: false,
        auto_status: false
      },
      reports: {
        ca: [],
        auto_ca: [],
        status: [],
        auto_status: []
      },
      pageNum: 1
    };
  },
  computed: {
    ...mapState("user", ["auth"]),
    ...mapState("clients", ["dictionaries", "salesPersonList"])
  },
  created() {
    this.execStatsAsync();
  },
  methods: {
    async execStatsAsync() {
      await this.getUserScheduledCallsByCa("ca");
      await this.getStatusScheduledCallsByCa("status");
      await this.getUserScheduledCallsByCa("auto_ca");
      await this.getStatusScheduledCallsByCa("auto_status");
    },
    paginate(arr, page_number, page_size) {
      return arr.slice((page_number - 1) * page_size, page_number * page_size);
    },
    nextPage() {
      this.pageNum = this.pageNum + 1;
    },
    backPage() {
      if (this.pageNum > 1) {
        this.pageNum = this.pageNum - 1;
      }
    },

    async getUserScheduledCallsByCa(caType) {
      if (
        !this.reqReportsBusy[caType] &&
        this.checkPermissions(this.auth, [1, 2, 3, 4, 12])
      ) {
        try {
          this.reqReportsBusy[caType] = true;
          const res = await apiClientCreator(
            `reports/scheduled_calls/user/regular/${caType}`
          ).get("");
          this.reports[caType] = res.data;
          this.reports[caType].sort((a, b) => {
            if (a.count_month > b.count_month) {
              return -1;
            }
            if (a.count_month < b.count_month) {
              return 1;
            }
            return 0;
          });
          this.reqReportsBusy[caType] = false;
        } catch (e) {}
      }
    },
    async getStatusScheduledCallsByCa(caType) {
      if (
        !this.reqReportsBusy[caType] &&
        this.checkPermissions(this.auth, [1, 2, 3, 4, 12])
      ) {
        try {
          this.reqReportsBusy[caType] = true;
          const res = await apiClientCreator(
            `reports/scheduled_calls/status/regular/${caType}`
          ).get("");
          this.reports[caType] = res.data;
          this.reports[caType].sort((a, b) => {
            if (a.count_month > b.count_month) {
              return -1;
            }
            if (a.count_month < b.count_month) {
              return 1;
            }
            return 0;
          });
          this.reqReportsBusy[caType] = false;
        } catch (e) {}
      }
    },
    checkPermissions(user, permitted) {
      return permitted.some(role => role === user.user.role);
    }
  }
};
</script>

<style scoped>
.body-div {
  padding: 4px 5px 1px 5px;
}
.top-div {
  width: 100%;
  height: max-content;
  margin: auto;
  background: white;
  border-radius: 3px;
  padding: 5px;
}
.bottom-div {
  width: 100%;
  height: 650px;
  overflow-y: scroll;
  margin: 5px auto;
  background: white;
  border-radius: 3px;
  padding: 5px;
  position: relative;
}
.fab {
  background-color: transparent;
  padding: 0;
  font-size: 30px;
  line-height: 30px;
  color: green;
  text-align: center;
  position: absolute;
  right: 10px;
  bottom: 10px;
  border-radius: 20%;
  transition: all 0.1s ease-in-out;
  cursor: pointer;
}

.fab:hover {
  box-shadow: 0 5px 11px 0 #666;
  transform: scale(1.05);
}
.table {
  /* float: left;*/
  display: flex;
  flex-direction: column;
  margin-top: 10px;
  margin-bottom: 10px;
}
.table table {
  font-size: 12px;
  /*   margin-right: auto;*/
  margin: 15px 7px;
}
.table thead {
  border-bottom: solid 2px #eff3f6;
}
.table th {
  text-align: left;
  font-size: 12px;
}
.table .td-count {
  text-align: center;
}
.table td {
  border-bottom: solid 2px #eff3f6;
}
.text-center {
  font-weight: bold;
}

.paginationContainer {
  /*margin-left: 10px;*/
  font-size: 15px;
  width: 110px;
  margin-left: auto;
  margin-right: auto;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}
.page-btn {
  background: white;
}

.page-num {
  cursor: inherit;
}
.loader {
  position: absolute;
  top: 100px;

  left: 0;
  right: 0;
}
.flat-bottom-div {
  margin-top: 10px;
  height: 40px;
  width: 100%;
}
/*.table table {
  font-size: 13px;
  width: 200px;
  margin-right: auto;
  margin-left: auto;

}
.table tbody{
  display: block;
  height: 332px;
  overflow: auto;
  width: 100%

}
.table thead tr {
  border-bottom: solid 2px #eff3f6;
  position: relative;

}*/
</style>
